import React from "react";
import "./FloatingButtons.css";
import { FaWhatsapp, FaInstagram, FaYoutube } from "react-icons/fa";

export default function FloatingButtons() {
  return (
    <div className="floating-buttons">
      <a
       href={`https://wa.me/584129034967?text=${encodeURIComponent(
    "Hola, estoy interesado en tus servicios"
  )}`}
  target="_blank"
  rel="noopener noreferrer"
        className="floating-btn whatsapp"
      >
        <FaWhatsapp />
      </a>

      <a
        href="https://www.instagram.com/glackstudios/"
        target="_blank"
        rel="noopener noreferrer"
        className="floating-btn instagram"
      >
        <FaInstagram />
      </a>
      <a
        href="https://www.youtube.com/@glackstudios"
        target="_blank"
        rel="noopener noreferrer"
        className="floating-btn instagram"
      >
        <FaYoutube />
      </a>
    </div>
  );
}
